// src/components/AccordionPanel.js
import React from 'react';
import AudioPlayer from './AudioPlayer';

const AccordionPanel = ({ playlist, id, isOpen, onToggle }) => {
    return (
        <div className="accordionPanel">
            <div className="accordionHeader" onClick={() => onToggle(id)}>
                <h3 className="accordionTitle">
                    {playlist.name} ({playlist.sentences.length} files)
                </h3>
                <span className="accordionToggle">{isOpen ? '▲' : '▼'}</span>
            </div>
            {isOpen && (
                <div className="accordionContent">
                    <AudioPlayer playlistName={playlist.name} language={playlist.language} />
                </div>
            )}
        </div>
    );
};

export default AccordionPanel;
